import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { FaPlane } from "react-icons/fa";

const flights = [
  { from: "DEL", to: "BOM", date: "08/20/2025", price: 5800, airline: "/assets/airindia.png" },
  { from: "BLR", to: "PNQ", date: "08/17/2025", price: 8718, airline: "/assets/airindia.png" },
  { from: "AMD", to: "BLR", date: "08/26/2025", price: 26730, airline: "/assets/xl.png" },
  { from: "PNQ", to: "IDR", date: "08/20/2025", price: 11206, airline: "/assets/airindia.png" },
  { from: "DEL", to: "DXB", date: "09/02/2025", price: 18200, airline: "/assets/emirates.png" },
  { from: "BOM", to: "SIN", date: "09/05/2025", price: 22450, airline: "/assets/singapore.png" },
  { from: "CCU", to: "BKK", date: "09/08/2025", price: 17600, airline: "/assets/thai.png" },
  { from: "DEL", to: "LHR", date: "09/10/2025", price: 54200, airline: "/assets/british.png" },
  { from: "MAA", to: "KUL", date: "09/12/2025", price: 13400, airline: "/assets/malaysia.png" },
  { from: "BOM", to: "JFK", date: "09/15/2025", price: 72100, airline: "/assets/airindia.png" },
  { from: "HYD", to: "MCT", date: "09/18/2025", price: 9800, airline: "/assets/oman.png" },
];

const TopAirlines = () => {
  return (
    <section className="bg-white/60 backdrop-blur-md border border-gray-200 max-w-7xl mx-auto px-4 py-10 rounded-2xl shadow-lg">
      
      <h2 className="text-xl font-bold mb-6 flex items-center gap-2 text-blue-900">
        <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
        Top Airlines Deals
      </h2>

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={3}
        autoplay={{ delay: 2500 }}
        pagination={{ clickable: true }}
        navigation
        breakpoints={{
          1280: { slidesPerView: 3 },
          900: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
      >
        {flights.map((flight, index) => (
          <SwiperSlide key={index}>
            <div className="bg-white/80 backdrop-blur-xl border border-gray-300 rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              
              {/* Top Section */}
              <div className="flex items-center gap-3 p-4 bg-gradient-to-r from-blue-100 to-blue-50">
                <img
                  src={flight.airline}
                  alt="Airline Logo"
                  className="w-14 h-14 rounded-lg border bg-white object-contain shadow"
                />

                <div className="flex-1">
                  <div className="flex justify-between text-[10px] sm:text-xs text-gray-500">
                    <span>From</span>
                    <span>To</span>
                  </div>

                  <div className="flex justify-between items-center text-lg sm:text-xl font-bold text-orange-600">
                    <span>{flight.from}</span>
                    <FaPlane className="text-blue-600" />
                    <span>{flight.to}</span>
                  </div>
                </div>
              </div>

              {/* Bottom Section */}
              <div className="px-4 py-3 text-sm sm:text-base">
                <div className="flex justify-between mb-2">
                  <div>
                    <div className="text-gray-500">Date</div>
                    <div className="font-semibold">{flight.date}</div>
                  </div>

                  <div className="text-right">
                    <div className="text-gray-500">Per Person</div>
                    <div className="text-xl font-extrabold text-blue-900">
                      ${Math.round(flight.price / 85)}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default TopAirlines;
